import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const KnowledgeSourceDetailsForNRO = lazy(() =>
  import("@scenes/KnowledgeSourceDetails").then((module) => ({
    default: module.KnowledgeSourceDetails,
  }))
);

export const knowledgeSourceEditNRO: NavigationRoutingObject = {
  Component: KnowledgeSourceDetailsForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "agent-console",
  heading: (t: I18nT<"dashboard-navigation">) => t("knowledge-source-edit-nro-heading", "Edit Knowledge Source"),
  pageNameForTracking: () => "Edit Knowledge Source",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("agent_console_knowledge_source") &&
      hasPermission("appGroup", { permission: "viewKnowledgeSources" })
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/knowledge_source/edit/:knowledgeSourceId/:appGroupId",
};
